import { render, staticRenderFns } from "./TheDisasterRecovery.vue?vue&type=template&id=28d1fec8&"
import script from "./TheDisasterRecovery.vue?vue&type=script&lang=js&"
export * from "./TheDisasterRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports